/**
 * Iter 61 — Global axios interceptor that appends `lang=` to every
 * call to /predictions/{id}/analysis so the backend can serve the
 * Expert Analysis narrative in the user's chosen language.
 *
 * Reads the current language from i18next (which mirrors the
 * `ndaku_lang` localStorage entry).  Non-analysis requests pass
 * through untouched.
 */
import axios from "axios";
import i18n from "./i18n";

const ANALYSIS_PATH_RE = /\/predictions\/[^/]+\/analysis(\/|$|\?)/;

axios.interceptors.request.use((config) => {
  try {
    const url = config?.url || "";
    if (!ANALYSIS_PATH_RE.test(url)) return config;

    const raw = i18n?.language || "en";
    const lang = String(raw).split("-")[0].split("_")[0].toLowerCase();

    // Don't overwrite an explicit caller-supplied lang.
    const paramsAlreadyHasLang =
      (config.params && ("lang" in config.params)) ||
      url.includes("?lang=") || url.includes("&lang=");
    if (paramsAlreadyHasLang) return config;

    config.params = { ...(config.params || {}), lang };
    return config;
  } catch {
    return config;
  }
});

export default axios;
